import { Plugin } from '../../types'
import { getRandomId } from '../../utils/urPlayerUtils'

const ASPECT_RATIO = 16 / 9
const LOGO_MARGIN_FRACTION = 1 / 20
const LOGO_SIZE_FRACTION = 1 / 30

const LOGO_HEIGHT_OFFSET_FRACTION = 0.2

const OVERLAY_DIV_STYLE = `
  z-index: 1;
  display: none;
  position: absolute;
  height: 30%;
  width: 100%;
  right: 0;
`

const SVG_STYLE = `
  position: absolute;
  right: 18px;
  top: 18px;
  width: 22px;
  height: 22px;
  color: white;
  opacity: 0.8
`

export const getCalculatedStyles = (baseWidth: number, baseHeight: number) => {
  let movieHeight
  let movieWidth
  if (baseWidth / baseHeight <= ASPECT_RATIO) {
    movieHeight = baseWidth * (1 / ASPECT_RATIO)
    movieWidth = baseWidth
  } else {
    movieHeight = baseHeight
    movieWidth = baseHeight * ASPECT_RATIO
  }

  const logoMargin = movieWidth * LOGO_MARGIN_FRACTION

  const movieMarginTop = (baseHeight - movieHeight) / 2
  const movieMarginRight = (baseWidth - movieWidth) / 2

  const logoSize = movieWidth * LOGO_SIZE_FRACTION
  const logoOffset = logoSize * LOGO_HEIGHT_OFFSET_FRACTION

  return {
    height: `${logoSize}px`,
    width: `${logoSize}px`,
    top: `${movieMarginTop + logoMargin - logoOffset}px`,
    right: `${movieMarginRight + logoMargin}px`,
  }
}

const setLogoSizeAndMargins = (
  baseWidth: number,
  baseHeight: number,
  logoId: string,
) => {
  const styles = getCalculatedStyles(baseWidth, baseHeight)

  const playerLogoSVG = document.getElementById(logoId)

  if (playerLogoSVG) {
    playerLogoSVG.style.height = styles.height
    playerLogoSVG.style.width = styles.width

    playerLogoSVG.style.top = styles.top
    playerLogoSVG.style.right = styles.right
  }
}

const addOverlayToPlayer = (div: HTMLElement) =>
  document.getElementsByClassName('jw-media')[0].appendChild(div)

const getSvgLogo = (
  id: string,
) => `<svg id=${id} xmlns="http://www.w3.org/2000/svg" width="200" height="200" viewBox="0 0 200 200" style="${SVG_STYLE}">
<path fill="#FFF" fill-rule="evenodd" d="M169.92 125.104c13.91-8.81 23.22-24.207 23.019-41.648C193.253 56.257 170.449 34 143.115 34H76.347v87.325c0 12.838-8.964 20.61-20.02 20.61-11.058 0-20.022-7.772-20.022-20.61V34H0v82.572C0 153.03 25.218 174 56.326 174c31.109 0 56.325-20.97 56.325-57.428V64.85h26.147c10.995 0 20.3 8.564 20.625 19.5.336 11.364-8.852 20.713-20.197 20.713H117.4l43.065 66.312H200l-30.08-46.272z"/>
</svg>`

const createOverlay = () => {
  const overlayDiv = document.createElement('div')

  const overlayId = `logoOverlay-${getRandomId()}`
  const logoId = `logo-${getRandomId()}`

  overlayDiv.setAttribute('class', 'logo-overlay')
  overlayDiv.setAttribute('id', overlayId)

  overlayDiv.setAttribute('style', OVERLAY_DIV_STYLE)

  overlayDiv.innerHTML = getSvgLogo(logoId)

  return {
    overlayDiv,
    overlayId,
    logoId,
  }
}

const logoOverlay: Plugin = (jwPlayer: jwplayer.JWPlayer) => {
  const { overlayDiv, overlayId, logoId } = createOverlay()

  addOverlayToPlayer(overlayDiv)

  setLogoSizeAndMargins(jwPlayer.getWidth(), jwPlayer.getHeight(), logoId)

  jwPlayer.on('play', () => {
    const overlay = document.getElementById(overlayId)
    if (overlay) {
      overlay.style.display = 'block'
    }
  })

  jwPlayer.on('fullscreen', () => {
    if (jwPlayer.getFullscreen()) {
      setLogoSizeAndMargins(window.screen.width, window.screen.height, logoId)
    } else {
      setLogoSizeAndMargins(jwPlayer.getWidth(), jwPlayer.getHeight(), logoId)
    }
  })
  jwPlayer.on(
    'resize',
    ({ width, height }: { width: number; height: number }) => {
      setLogoSizeAndMargins(width, height, logoId)
    },
  )
}

export default logoOverlay
